import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-20 lg:pt-44 lg:pb-32 overflow-hidden aw-grain"
    >
      {/* soft organic blobs */}
      <div
        aria-hidden
        className="absolute -top-32 -left-32 h-[480px] w-[480px] rounded-full bg-[#8A9A86]/25 blur-3xl aw-blob"
      />
      <div
        aria-hidden
        className="absolute top-40 -right-40 h-[520px] w-[520px] rounded-full bg-[#D8B4A0]/30 blur-3xl aw-blob"
        style={{ animationDelay: "4s" }}
      />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Left copy */}
        <div className="lg:col-span-7">
          <p
            data-testid="hero-eyebrow"
            className="aw-rise text-xs tracking-eyebrow uppercase text-sage mb-8 flex items-center gap-3"
          >
            <Sparkles size={14} className="text-clay" />
            A wellness &amp; transformation space
          </p>

          <p
            data-testid="hero-lead"
            className="aw-rise font-serif-display italic text-forest text-2xl sm:text-3xl lg:text-[2rem] leading-snug max-w-2xl mb-10"
          >
            A gentle, grounded path back to self-love, affirmation, and the
            quiet power that has always lived within you.
          </p>

          <h1
            data-testid="hero-headline"
            className="aw-rise delay-1 font-serif-display text-forest text-[3.4rem] sm:text-6xl lg:text-[5.5rem] leading-[0.95] tracking-tight"
          >
            Heal.
            <br />
            <span className="italic text-forest-soft">Release.</span>
            <br />
            Rise.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="aw-rise delay-2 mt-10 max-w-xl text-forest-soft text-lg lg:text-xl leading-relaxed font-light"
          >
            Make the unconscious, conscious. Change your thinking, change your
            life.
          </p>

          <div className="aw-rise delay-3 mt-12 flex flex-wrap items-center gap-4">
            <a
              href="#connect"
              data-testid="hero-cta-primary"
              className="aw-btn-primary"
            >
              Book a Discovery Call
              <ArrowRight size={16} className="-mr-1" />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="aw-btn-ghost"
            >
              Explore Packages
            </a>
          </div>

          <div className="aw-rise delay-4 mt-14 flex items-center gap-8 text-sm text-forest-soft">
            <div>
              <p className="font-serif-display text-3xl text-forest leading-none">
                1:1
              </p>
              <p className="mt-1 tracking-wide">Private coaching</p>
            </div>
            <div className="h-10 w-px bg-forest/15" />
            <div>
              <p className="font-serif-display text-3xl text-forest leading-none">
                6–10
              </p>
              <p className="mt-1 tracking-wide">Session packages</p>
            </div>
            <div className="h-10 w-px bg-forest/15 hidden sm:block" />
            <div className="hidden sm:block">
              <p className="font-serif-display text-3xl text-forest leading-none">
                ∞
              </p>
              <p className="mt-1 tracking-wide">Inner power</p>
            </div>
          </div>
        </div>

        {/* Right image collage */}
        <div className="lg:col-span-5 relative aw-fade delay-2">
          <div className="relative aspect-[4/5] w-full max-w-md mx-auto">
            <div className="absolute inset-0 rounded-[42%_58%_60%_40%/45%_55%_45%_55%] bg-[#8A9A86]/30 aw-blob" />
            <img
              src="https://customer-assets.emergentagent.com/job_align-wellness-hub/artifacts/oes25el0_2026%20Profile%20Pic.jpeg"
              alt="Tammy, founder of Align Wellness"
              data-testid="hero-image"
              className="absolute inset-2 object-cover rounded-[42%_58%_60%_40%/45%_55%_45%_55%] aw-shadow-lg"
            />
            <div className="absolute -bottom-6 -left-6 hidden sm:flex items-center gap-3 bg-[#FAF9F6] border border-sage/30 rounded-full pl-2 pr-5 py-2 aw-shadow">
              <span className="h-10 w-10 rounded-full overflow-hidden ring-1 ring-[#D8B4A0]/60">
                <img
                  src="https://customer-assets.emergentagent.com/job_align-wellness-hub/artifacts/oes25el0_2026%20Profile%20Pic.jpeg"
                  alt="Tammy"
                  className="h-full w-full object-cover"
                />
              </span>
              <div className="leading-tight">
                <p className="text-[11px] tracking-eyebrow uppercase text-sage">
                  Founder
                </p>
                <p className="font-serif-display text-lg text-forest">Tammy</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
